export default __webpack_public_path__ + "static/media/html.1e1cc118.png";